function deFormatText(key: string): string {
  return key.toLowerCase().split(" ").join("_");
}

export { deFormatText };
export default deFormatText;
